import {defaultWidgetSetting} from '@functions/const/defaultWidgetSetting.js';

export default function prepareEnableDisclaimerConsent(widgetSettings) {
  if (widgetSettings.hasOwnProperty('isEnableDisclaimerConsent')) {
    return widgetSettings.isEnableDisclaimerConsent;
  }
  if (typeof widgetSettings.newsletterPopupSettings?.showDisclaimerConsent === 'boolean') {
    return widgetSettings.newsletterPopupSettings?.showDisclaimerConsent;
  }
  return defaultWidgetSetting.isEnableDisclaimerConsent;
}
